import React, { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

// Löscht eine nicht an den Kunden versendete, unbezahlte Anzahlungsrechnung (Admin/Direktor).
export const DeleteInvoiceButton = ({ offerId, inv, onDeleted }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!window.confirm(`Rechnung ${inv.invoice_number} (${inv.percent} %) wirklich löschen? Sie wurde noch nicht an den Kunden versendet.`)) return;
    setBusy(true);
    try {
      await api.delete(`/offers/${offerId}/invoices/${inv.id}`);
      toast.success(`Rechnung ${inv.invoice_number} gelöscht`);
      onDeleted?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Löschen fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      onClick={run}
      disabled={busy}
      title="Nicht versendete Rechnung löschen"
      data-testid={`invoice-delete-${inv.id}`}
      className="h-8 px-2 rounded-lg bg-red-500/10 hover:bg-red-500/20 border border-red-500/30 text-red-300 inline-flex items-center gap-1 text-[11.5px] transition-colors disabled:opacity-50"
    >
      {busy ? <Loader2 size={11} className="animate-spin" /> : <Trash2 size={12} />}
    </button>
  );
};

export const FullyBilledNote = ({ testid }) => (
  <div data-testid={testid} className="text-[11.5px] text-zinc-300 bg-[#00E575]/8 border border-[#00E575]/30 rounded-lg px-3 py-2">
    100 % der Auftragssumme sind bereits über Anzahlungsrechnungen abgerechnet – keine weitere Anzahlungsrechnung nötig.
  </div>
);
